import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {voucherTypeBasicInformationPropTypes} from '../proptypes/VoucherTypePropTypes';
import Checkbox from '../../../../common/forms/Checkbox';

const VoucherTypeBasicInformationResource = ({
    name, description, displayInPaymentsPage, voucherCode
}) => (
  <>
    <ResourceProperty label="Name:">{name}</ResourceProperty>
    <ResourceProperty label="Código:">
      {voucherCode}
    </ResourceProperty>
    <ResourceProperty label="">
      <Checkbox checked={displayInPaymentsPage} label='Mostrar en Página de Pagos'/>
      {' '}Mostrar en Página de Pagos
    </ResourceProperty>
    <ResourceProperty label="Descripción:">
      {description}
    </ResourceProperty>
  </>
);

VoucherTypeBasicInformationResource.propTypes =
  voucherTypeBasicInformationPropTypes;

export default VoucherTypeBasicInformationResource;
